import UseFeature from './UseFeature'

export default UseFeature
